import { QueryClientProvider } from "@tanstack/react-query";
import { ConfigProvider } from "antd";
import PropTypes from 'prop-types';
import enUS from 'antd/locale/en_US';
import frFR from 'antd/locale/fr_FR';
import ptBR from 'antd/locale/pt_BR';
import esES from 'antd/locale/es_ES';
import hiIN from 'antd/locale/hi_IN';

import queryClient from "@/utils/queryClient";
import antdTheme from "@/utils/antdTheme";
import useLocalStore from "@/hooks/useLocalStore";
import "@/index.scss"

const ANTD_LOCALES = { en: enUS, fr: frFR, pt: ptBR, es: esES, hi: hiIN };

export default function AppProviders({ children }) {
    const language = useLocalStore((s) => s.language) || "en";
    const locale = ANTD_LOCALES[language] ?? enUS;

    return (
        <QueryClientProvider client={queryClient}>
            <ConfigProvider theme={antdTheme} locale={locale}>
                {children}
            </ConfigProvider>
        </QueryClientProvider>
    );
}

AppProviders.propTypes = {
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
}